<template>
  <div class="search-guide">
    <h3>Search tips</h3>
    <div class="row">
      <div class="col">
        <ul>
          <li>The standard search is designed to look for individual characters; to search an entire string, wrap it in double quotation marks: ""</li>
          <li>The "View entries" mode shows results by title; for a preview of the actual passages in the text, switch to the "View passages" mode</li>
          <li>Use the filters in the faceted search to refine your search results</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
  // TODO: Factor out to a variables file
  $font-family-secondary: 'Noto Sans', 'Noto Sans Coptic';
  $brill-blue: #0f356c;
  $brand-color: $brill-blue;
  $gray-600: #868e96;
  $gray-100: #f8f9fa;
  $gray-700: #495057;

  .search-guide {
    h3 {
      font-family: $font-family-secondary;
      font-size: 14px;
      margin: 0 0 0.5em;
      color: $gray-600;
      text-transform: uppercase;
      letter-spacing: 0.2em;
    }
    margin: 1.0em 0;
    background: $gray-100;
    padding: 15px 20px;
    font-size: 14px;
    line-height: 24px;
    color: $gray-700;
    kbd {
      background: $brand-color
    }
    .first-fixed-width {
      width: 4rem;
      max-width: 5rem;
    }
  }
</style>
